// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__mDPUe","footerLeft":"styles_footerLeft__IThXo","footerRight":"styles_footerRight__5xkEC"};